module.exports = __webpack_public_path__ + "media/images/icon-success-a535134cf36089d5fc3616e1788966be.svg";